import {Injectable} from '@angular/core';
import {HttpModelConverter} from "../../../../../core/converter/httpModel.converter";
import {InsolesProviderModelModel} from "./insolesProviderModel.model";
import {InsolesProviderModelSummaryConverter} from "./insolesProviderModelSummary.converter";
import {InsolesModelConverter} from "../../../../insolemodel/api/entity/insolesModel.converter";
import {InsolesProviderModelMaterialConverter} from "./insolesProviderModelMaterial.converter";
import {ProviderSummaryConverter} from "../../../../../provider/common/api/entity/converter/providerSummary.converter";
import {InsolesProviderModelGabaritConverter} from "./insolesProviderModelGabarit.converter";
import {InsolesProviderModelCamMachineModel} from "./insolesProviderModelCamMachine.model";
import {InsolesProviderModelCamMachineConverter} from "./insolesProviderModelCamMachine.converter";
import {
    ProviderServiceSummaryConverter
} from "../../../../../provider/service/api/entity/converter/providerServiceSummary.converter";

@Injectable({
    providedIn: 'root'
})
export class InsolesProviderModelConverter extends HttpModelConverter<InsolesProviderModelModel> {

    constructor(private summaryConverter: InsolesProviderModelSummaryConverter,
                private insolesModelConverter: InsolesModelConverter,
                private providerServiceSummaryConverter: ProviderServiceSummaryConverter,
                private materialConverter: InsolesProviderModelMaterialConverter,
                private insolesProviderModelGabaritConverter: InsolesProviderModelGabaritConverter,
                private insolesProviderModelCamMachineConverter: InsolesProviderModelCamMachineConverter) {
        super();
    }

    protected createInstance(): InsolesProviderModelModel {
        return new InsolesProviderModelModel();
    }

    protected enrichObject(result: InsolesProviderModelModel, src: InsolesProviderModelModel) {
        result.summary = this.summaryConverter.convert(src.summary);
        result.model = this.insolesModelConverter.convert(src.model);
        result.materials = this.materialConverter.convertFromArray(src.materials);
        result.providerService = this.providerServiceSummaryConverter.convert(src.providerService);
        result.gabarits = this.insolesProviderModelGabaritConverter.convertFromArray(src.gabarits);
        result.camMachines = this.insolesProviderModelCamMachineConverter.convertFromArray(src.camMachines)
    }
}
